/* eslint-disable @typescript-eslint/no-require-imports */
/* eslint-disable import/no-webpack-loader-syntax */
import { $t } from '@/i18n';
import { memoize } from 'lodash';
import { createRouterForGogo } from './vue3router';
import { loadEditorCdn } from './editor-cdn-loader';
import { showEditorLoadError } from './showEditorLoadError';
export const loadVue3Stuff = memoize(async () => {
    // @ts-ignore
    const $vue3part2 = import('@tencent/wuji-vue-next').then(x => x.default || x);
    const { moduleManage } = window.wujiComp;
    const { allWebpackExternals } = moduleManage;
    if (!allWebpackExternals.vue3)
        await moduleManage.loadVue3Dependencies();
    // @ts-ignore
    const tdesign = await import('@tencent/wuji-vue-next/dist/tdesign.es.js');
    const vue3part2 = await $vue3part2;
    const routerInstance = createRouterForGogo(vue3part2.vueRouter, allWebpackExternals.vue3);
    const ans = {
        routerInstance,
        vue: allWebpackExternals.vue3,
        vueRouter: vue3part2.vueRouter, // 在 allWebpackExternals 没有 —— 等后面 maoyi 看看
        'ant-design-vue': allWebpackExternals.vue3Antd,
        'tdesign-vue-next': tdesign,
        Vue3Adaptor: allWebpackExternals.Vue3Adaptor,
    };
    for (const [key, value] of Object.entries(ans)) {
        window.define(`gogo-env/${key}`, [], () => value);
    }
    return ans;
});
if (typeof XY_GPT_HOST_URL === 'string') {
    // 这段代码只会在开发环境下有（开发环境才有 XY_GPT_HOST_URL 环境变量），所以应该是安全的
    let gptHostUrl = XY_GPT_HOST_URL;
    const port = /:(\d+)/.exec(gptHostUrl)?.[1] || '5173';
    if (/\d+\.\w+\.cloudide\.woa\.com/.test(window.location.origin)) {
        // 龙虾开发机的地址类似 XXXXX-1024.gz.cloudide.woa.com 这种
        gptHostUrl = window.location.origin.replace(/-\d+/, `-${port}`);
    }
    else if (window.location.origin.includes('devcloud.woa.com')) {
        // 开发云的地址类似 XXXXX.devcloud.woa.com:1024 这种
        gptHostUrl = window.location.origin.replace(/(:\d+)?$/, `:${port}`);
    }
    window.GPT_HOST_URL = gptHostUrl;
}
const waitForEditorInit = (vue) => new Promise((resolve, reject) => {
    let attempts = 0;
    const maxAttempts = 50;
    const timer = setInterval(() => {
        attempts += 1;
        const { getWujiGogoEditor } = window;
        if (typeof getWujiGogoEditor !== 'function') {
            if (attempts >= maxAttempts) {
                clearInterval(timer);
                reject(new Error(`[xy-client] getWujiGogoEditor not available after ${maxAttempts} attempts`));
            }
            return;
        }
        clearInterval(timer);
        try {
            resolve(getWujiGogoEditor({ vue }));
        }
        catch (error) {
            reject(error);
        }
    }, 100);
});
const gogoLibMapSource = {
    editor: async () => {
        const gogoEditorVersion = require('@tencent/wuji-gogo-editor/package.json')?.version || '';
        const serveSubPath = XY_USE_LOCAL_GOGO ? 'gogo-editor-dev' : `gogo-editor-${gogoEditorVersion}`;
        const baseUrl = `${window.GLOBAL_INFO.staticFileCdn || window.GLOBAL_INFO.pathPrefix}/xystatic/${serveSubPath}`;
        const $setupShiki = import('./setupShiki').then(x => x.setupShiki);
        let js;
        try {
            const { vue } = await loadVue3Stuff();
            js = await loadEditorCdn(baseUrl, () => waitForEditorInit(vue));
        }
        catch (e) {
            return showEditorLoadError({ baseUrl, editorVersion: gogoEditorVersion, error: e });
        }
        console.log('js', XY_USE_LOCAL_GOGO, js);
        const setupShiki = await $setupShiki;
        setupShiki(js.monaco);
        return js;
    },
    runtime: async () => {
        await loadVue3Stuff(); // 确保 vue3 ready
        const [js] = await Promise.all([
            import('@tencent/wuji-gogo-runtime'),
            // @ts-ignore - style import may not have types
            import(/* webpackChunkName: "gogo-runtime-css" */ '@tencent/wuji-gogo-runtime/index.css'),
        ]);
        return js;
    },
};
export const loadGogoLib = memoize(async (key) => gogoLibMapSource[key]());
// 创建 Pinia installer plugin，确保每个 Vue3Adaptor 实例拥有独立的 Pinia
const createPiniaPlugin = (pinia) => ({
    install(app) {
        app.use(pinia.createPinia());
    },
});
/**
 * 一个 Vue2 异步的组件，提供了 GogoEditor
 *
 * see https://v2.vuejs.org/v2/guide/components-dynamic-async#Handling-Loading-State
 */
export const AsyncGogoEditor = memoize(() => {
    const component = (async () => {
        const stuff = await loadVue3Stuff();
        const gogo = await loadGogoLib('editor');
        return stuff.Vue3Adaptor.default(gogo.GogoEditor, { library: 'tdesign', plugins: [createPiniaPlugin(gogo.pinia)] });
    })();
    return {
        component,
        delay: 300,
        loading: {
            render() {
                return <div class='flex flex-col items-center justify-center'>
          <t-loading />
          <div class='animate-fade-in mt-4 text-gray-8'>{$t('k_c33419b7')}</div>
        </div>;
            },
        },
    };
});
/**
 * 一个 Vue2 异步的组件，提供了 GogoEditor 的 Entrance 界面
 */
export const AsyncGogoEditorEntrance = memoize(() => {
    const component = (async () => {
        const stuff = await loadVue3Stuff();
        const gogo = await loadGogoLib('editor');
        return stuff.Vue3Adaptor.default(gogo.StartGuide, { library: 'tdesign', plugins: [createPiniaPlugin(gogo.pinia)] });
    })();
    return {
        component,
        loading: {
            render() {
                return <div class='w-full h-full bg-white'></div>;
            },
        },
    };
});
/**
 * 一个 Vue2 异步的组件，提供了 gogo-runtime 下面的东西
 *
 * see https://v2.vuejs.org/v2/guide/components-dynamic-async#Handling-Loading-State
 */
const getGogoRuntimeComponent = memoize((exportName) => {
    const component = (async () => {
        const stuff = await loadVue3Stuff();
        const gogo = await loadGogoLib('runtime');
        const { pinia } = gogo;
        const router = stuff.routerInstance;
        const comp = stuff.Vue3Adaptor.default(gogo[exportName], { library: 'tdesign', plugins: [router, pinia] });
        return comp;
    })();
    return {
        component,
        delay: 300,
        loading: {
            render() {
                return <div class='flex flex-col items-center justify-center'>
          <t-loading />
        </div>;
            },
        },
    };
});
export const AsyncGogoHost = () => getGogoRuntimeComponent('GogoHost');
export const AsyncGogoRouteView = () => getGogoRuntimeComponent('GogoRouteView');
// --- React Runtime ---
export const loadReactStuff = memoize(async () => {
    const [gogoReactRuntime, 
    // @ts-ignore
    ReactModule, 
    // @ts-ignore
    ReactDOM, 
    // @ts-ignore
    ReactDOMClient, 
    // @ts-ignore
    ReactRouterDom,] = await Promise.all([
        import('@tencent/wuji-gogo-runtime-react'),
        // @ts-ignore
        import('@tencent/wuji-react/react'),
        // @ts-ignore
        import('@tencent/wuji-react/react-dom'),
        // @ts-ignore
        import('@tencent/wuji-react/react-dom/client'),
        // @ts-ignore
        import('@tencent/wuji-react/react-router-dom'),
    ]);
    return { gogoReactRuntime, ReactModule, ReactDOM, ReactDOMClient, ReactRouterDom };
});
/**
 * 轻量 React-in-Vue2 桥接组件。
 * 使用 React 19 的 createRoot API 挂载 React 组件，
 * watch props 变化时 re-render，beforeDestroy 时 unmount。
 */
function createReactBridge(ReactModule, ReactDOMClient, ReactComponent) {
    const { createElement: h } = ReactModule;
    function renderReact(vm) {
        if (!vm.$refs.container)
            return;
        if (!vm._reactRoot) {
            vm._reactRoot = ReactDOMClient.createRoot(vm.$refs.container);
        }
        vm._reactRoot.render(h(ReactComponent, vm.reactProps));
    }
    return {
        name: 'ReactBridge',
        props: {
            reactProps: { type: Object, default: () => ({}) },
        },
        render(createElement) {
            return createElement('div', { ref: 'container', style: 'display:contents' });
        },
        mounted() {
            renderReact(this);
        },
        watch: {
            reactProps: {
                deep: true,
                handler() {
                    renderReact(this);
                },
            },
        },
        beforeDestroy() {
            if (this._reactRoot) {
                this._reactRoot.unmount();
                this._reactRoot = null;
            }
        },
    };
}
function createReactGogoHostApp(ReactModule, ReactDOM, ReactRouterDom, ReactGogoHost, ReactGogoRouteView, useGogoHost) {
    const { createElement: h, useEffect, useRef, createContext, useContext } = ReactModule;
    const { createPortal } = ReactDOM;
    const { createMemoryRouter, RouterProvider } = ReactRouterDom;
    const vue2Router = window.xy_runtime_router;
    function getFullPath(loc) {
        return (loc.pathname || '/') + (loc.search || '') + (loc.hash || '');
    }
    function HostStatusBridge({ onHostStatusChanged }) {
        const host = useGogoHost();
        const prevStatusRef = useRef(null);
        useEffect(() => {
            if (!host || host.hostStatus === prevStatusRef.current)
                return;
            prevStatusRef.current = host.hostStatus;
            onHostStatusChanged?.(host.hostStatus, host.exports);
        }, [host?.hostStatus, host?.exports]);
        return null;
    }
    function PortalledRouteView({ container }) {
        if (!container)
            return null;
        return createPortal(h(ReactGogoRouteView, { notFound: h('div', null, 'Page not found') }), container);
    }
    const PropsContext = createContext(null);
    function ReactGogoHostAppInner() {
        const props = useContext(PropsContext);
        return h(ReactGogoHost, {
            content: props.content,
            prepareEnv: props.prepareEnv,
            debugAllowPicking: props.debugAllowPicking,
            debugIsErrorReportable: props.debugIsErrorReportable,
            debugBridgeInstanceName: props.debugBridgeInstanceName,
            onReady: props.onReady,
        }, h(HostStatusBridge, { onHostStatusChanged: props.onHostStatusChanged }), h(PortalledRouteView, { container: props.routeViewContainer }));
    }
    // 创建 React MemoryRouter 并建立与 Vue2 Router 的双向同步（类似 Vue3 链路的钩子方式）
    const initialPath = vue2Router?.currentRoute?.fullPath || '/';
    const reactRouter = createMemoryRouter([{ path: '/*', Component: ReactGogoHostAppInner }], { initialEntries: [initialPath] });
    let isSyncing = false;
    // React → Vue2
    reactRouter.subscribe((state) => {
        if (isSyncing || !vue2Router)
            return;
        const reactPath = getFullPath(state.location);
        if (vue2Router.currentRoute.fullPath !== reactPath) {
            isSyncing = true;
            vue2Router.push(reactPath).catch(() => { });
            Promise.resolve().then(() => {
                isSyncing = false;
            });
        }
    });
    // Vue2 → React
    if (vue2Router) {
        vue2Router.afterEach((to) => {
            if (isSyncing)
                return;
            const reactPath = getFullPath(reactRouter.state.location);
            if (reactPath !== to.fullPath) {
                isSyncing = true;
                reactRouter.navigate(to.fullPath, { replace: true });
                Promise.resolve().then(() => {
                    isSyncing = false;
                });
            }
        });
    }
    function ReactGogoHostApp(props) {
        return h(PropsContext.Provider, { value: props }, h(RouterProvider, { router: reactRouter }));
    }
    ReactGogoHostApp.displayName = 'ReactGogoHostApp';
    return { ReactGogoHostApp };
}
export const AsyncReactGogoHost = memoize(() => {
    const component = (async () => {
        const { gogoReactRuntime, ReactModule, ReactDOM, ReactDOMClient, ReactRouterDom } = await loadReactStuff();
        const { ReactGogoHost, ReactGogoRouteView, useGogoHost } = gogoReactRuntime;
        const { ReactGogoHostApp } = createReactGogoHostApp(ReactModule, ReactDOM, ReactRouterDom, ReactGogoHost, ReactGogoRouteView, useGogoHost);
        return createReactBridge(ReactModule, ReactDOMClient, ReactGogoHostApp);
    })();
    return {
        component,
        delay: 300,
        loading: {
            render() {
                return <div class='flex flex-col items-center justify-center'>
          <t-loading />
        </div>;
            },
        },
    };
});
